import { AiOff, Card, PageHead } from '@/components/ui';

export function AskPage() {
  return (
    <div className="page" style={{ maxWidth: 900 }}>
      <PageHead title="Ask the data" subtitle="Questions about usage, answered from the analytics views" />
      <Card>
        <AiOff what="Ask the data" />
      </Card>
    </div>
  );
}
